import React, { useEffect, useState } from 'react';
import { View, Text, Keyboard, TouchableWithoutFeedback, StyleSheet, BackHandler, Platform, Alert, StatusBar, TouchableOpacity, ScrollView, FlatList, Image, ActivityIndicator, RefreshControl } from 'react-native';
import Btn from "../components/btn"
import INPU from "../components/input"
import Colors from '../constants/Colors';
import { Ionicons, MaterialCommunityIcons } from "@expo/vector-icons"
import { Modal, NativeBaseProvider, useMediaQuery } from 'native-base';
import { DeleteMDFcolor, Deletewhite, getListMdfColor, getMdfWhite, SetMDFlist } from '../store/action/userProduct';
import { useDispatch, useSelector } from 'react-redux';
import { useIsFocused } from '@react-navigation/native';
import AwesomeAlert from 'react-native-awesome-alerts';
import { AddTicket, getTicket, logOut } from '../store/action/userLogin';
import AsyncStorage from '@react-native-async-storage/async-storage';









const Ticket = (props) => {

    const tokens = useSelector((store) => store.userLogin.datatoken);
    const dispatch = useDispatch();
    const [Wallet, setWallet] = useState(false)
    const [Message, setMessage] = useState()
    const [GetTicket, setGetTicket] = useState([]);
    const [Offset, setOffset] = useState(1);
    const [State, setState] = useState({
        showModal1: false,
        isLoading: false,
        isLoading1: false,
        title: "",
        msg: "",

    })

    const logOutHandler = async () => {
        try {
            //   console.log("logout");
            await dispatch(logOut());
            await AsyncStorage.removeItem("access_token");
            props.navigation.navigate("splash");
        } catch (err) {
            console.log(err);
        }
    };






    const getTicketHandler = async (reload = 'false') => {
        try {

            let offset = Offset;
            if (reload == 'true') {
                setOffset(1)
                offset = 1;
            }


            setState({ ...State, isLoading: true })
            const res = await dispatch(getTicket(tokens,
                offset,

            ));



            if (reload == 'true') {
                // console.log(Offset);
                setGetTicket([...res.data.data.tickets.data])

            } else {
                // console.log(Offset);
                setGetTicket([...GetTicket, ...res.data.data.tickets.data])

            }
            //console.log(res.data.data.tickets.data);


            setState({ ...State, isLoading: false })

        } catch (err) {
            // logOutHandler()
        }
    };








    const AddTicketHandler = async () => {
        try {

            setState({ ...State, isLoading1: true })
            const res = await dispatch(AddTicket(tokens, State.title, State.msg));


            if (res.status == "success") {
                setWallet(true)
                setMessage("با موفقیت ثبت شد")
            } else if (res.status == "error") {
                setWallet(true)
                setMessage("توضیحات الزامی می باشد")
            }
            setState({ ...State, isLoading1: false })
        } catch (err) {
            // logOutHandler()
        }
    };


    const isfocuce = useIsFocused();
    useEffect(() => {
        getTicketHandler("true");

        if (!tokens) {
            logOutHandler()
        }
        // getMDFCOLORandler();
    }, [Offset, isfocuce])








    function handleBackButtonClick() {

        props.navigation.goBack();
        return true;

    }

    useEffect(() => {
        BackHandler.addEventListener("hardwareBackPress", handleBackButtonClick);
        return () => {
            BackHandler.removeEventListener("hardwareBackPress", handleBackButtonClick);
        };
    }, []);







    const [isSmallScreen] = useMediaQuery({
        // minHeight: 280,
        // maxHeight: 480,
        maxWidth: 500
    });
    return (

        <NativeBaseProvider>


            <View style={{
                width: isSmallScreen ? "100%" : 500,
                height: "100%",
                backgroundColor: Colors.background,
                position: Platform.OS == "web" ? "fixed" : "relative"
            }}>


                <View style={styles.viewHeader}>
                    <StatusBar backgroundColor={Colors.primary} />
                    <TouchableOpacity onPress={() => props.navigation.goBack()} style={styles.menu}   >
                        <Ionicons name="arrow-forward-outline" size={25} color={Colors.background} />
                    </TouchableOpacity>

                    <TouchableOpacity onPress={() => props.navigation.goBack()} style={styles.textheader}>
                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.background, padding: "5%" }}>
                            پشتیبان
                        </Text>
                    </TouchableOpacity>

                </View>


                <Modal justifyContent="center" size="xl"
                    isOpen={State.showModal1} onClose={() => setState({ ...State, showModal1: false })}>
                    <Modal.Content style={{ borderRadius: 30 }}>
                        <Modal.Body >

                            <View style={{ width: "100%", alignSelf: "auto" }}>
                                <View style={{ width: "100%", height: 50, }}>
                                    <Ionicons onPress={() => setState({ ...State, showModal1: false })} name="close" size={20} color={Colors.black} />
                                </View>

                                <INPU
                                    label="عنوان"
                                    styleview={{ marginTop: "3%", height: 70 }}
                                    stylelabel={{ width: "13%", }}
                                    value={State.title}
                                    onChangeText={(text) => setState({ ...State, title: text })}
                                    styleinput={Platform.OS === "web" && { outlineColor: Colors.primary }}
                                    keyboardType="default"

                                />


                                <INPU
                                    label="توضیحات"
                                    multiline
                                    styleinput={{ height: 100 }}
                                    styleview={{ height: 100, marginBottom: "30%", marginTop: 20 }}
                                    stylelabel={{ width: 65, top: Platform.OS == "web" ? -9 : -15 }}
                                    keyboardType="default"
                                    value={State.msg}
                                    onChangeText={(text) => setState({ ...State, msg: text })}


                                //styleinput={Platform.OS === "web" && { outlineColor: Colors.primary }}

                                />

                                <Btn

                                    touchableStyle={{ width: "90%", height: 50, backgroundColor: Colors.yellowdark, }}
                                    textStyle={{ bottom: 10, fontSize: 16 }}
                                    style={{ position: "absolute", left: "5%", bottom: 10, }}
                                    onPress={() => {
                                        AddTicketHandler();
                                        if (Message == "با موفقیت ثبت شد") {
                                            setState({ ...State, showModal1: false })
                                        }

                                    }}
                                    colorspin={Colors.background}
                                    sizespin={25}
                                    label="افزودن "
                                    loading={State.isLoading1}

                                />
                            </View>


                        </Modal.Body>

                    </Modal.Content>
                </Modal>






                <View style={styles.viewmodal}>
                    <Btn
                        nameicon="plus"
                        sizeicon={30}
                        styleicon={{ position: "absolute", left: 120, top: Platform.OS === "web" ? -5 : -1, }}
                        coloricon={Colors.background}
                        touchableStyle={{ width: "90%", height: 50, backgroundColor: Colors.yellowdark, }}
                        textStyle={{ fontSize: 16 }}
                        style={{ position: "absolute", left: "5%", top: 10 }}
                        onPress={() => setState({ ...State, showModal1: true })}
                        colorspin={Colors.background}
                        sizespin={25}
                        label="ارسال پیام به پشتیبانی"

                    />

                </View>




                {State.isLoading ?
                    <View style={{ flexDirection: "row", width: 100, height: 40, backgroundColor: Colors.yellowdark, borderRadius: 10, alignItems: "center", justifyContent: "center", top: "90%", left: "35%", position: "absolute", zIndex: 2 }}>
                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.background, marginRight: 10 }}>
                            بیشتر
                        </Text>
                        <ActivityIndicator size={30} color={Colors.background} />
                    </View>
                    :
                    <View></View>}
                <FlatList

                    // refreshControl={
                    //     <RefreshControl
                    //         onRefresh={getTicketHandler}
                    //         refreshing={State.isLoading}
                    //         progressBackgroundColor={Colors.yellowlight}

                    //     />
                    // }

                    data={GetTicket}

                    onEndReachedThreshold={0.5}
                    keyExtractor={(item, index) => index.toString()}
                    onEndReached={() => setOffset(Offset + 1)}
                    enableEmptySections={true}
                    renderItem={({ item, index }) => {

                        return (

                            <TouchableOpacity key={index} onPress={() => {
                                props.navigation.navigate("chatticket", {
                                    Ticketid: item.id,
                                    type: item.status == "close" ? "ok" : ""
                                })
                            }} style={{
                                flexDirection: "column",
                                alignItems: "center",
                                width: "90%",
                                height: 80,
                                backgroundColor: Colors.background1,
                                marginTop: 10,
                                left: "5%",
                                borderWidth: 2,
                                borderColor: Colors.secondText,
                                borderRadius: 10,

                                marginBottom: GetTicket.length > 1 ? 10 : 290
                            }}>


                                <View style={styles.viewline} >

                                    <Text style={styles.textlineR}> عنوان : <Text style={styles.textline}>{item.title}</Text></Text>
                                </View>

                                <View style={styles.viewline} >

                                    <Text style={styles.textlineR}>وضعیت : <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: item.status == "pending" || item.status == "waiting" ? Colors.primary : Colors.success }}>{item.status == "pending" ? "در حال بررسی" : item.status == "waiting" ? "در انتظار پاسخ" : item.status == "awnser" ? "پاسخ داده شده" : " بسته شده"}</Text></Text>
                                </View>
                                {item.message.seen == "no" && item.message.status != "user" ?
                                    <View style={styles.payam}   >
                                        <MaterialCommunityIcons name={"bell-ring"} size={30} color={Colors.greenalarm} />
                                        <Text style={{ fontFamily: "Montserrat", fontSize: 10, color: Colors.success }}>پیام جدید </Text>
                                    </View>
                                    :
                                    <View></View>


                                }
                            </TouchableOpacity>

                        )




                    }}


                />



                <AwesomeAlert
                    show={Wallet}
                    showProgress={false}
                    title={Message == "با موفقیت ثبت شد" ? "" : "اخطار"}
                    message={Message}
                    closeOnTouchOutside={false}
                    closeOnHardwareBackPress={false}
                    // showCancelButton={true}
                    showConfirmButton={true}
                    // cancelText="باشه"
                    confirmText="باشه"
                    confirmButtonColor={Colors.success}
                    // onCancelPressed={() => {
                    //   setShow(false);
                    // }}
                    onConfirmPressed={() => {

                        if (Message == "با موفقیت ثبت شد") {
                            setWallet(false);
                            props.navigation.navigate("home")
                        } else {
                            setWallet(false);
                        }





                    }}
                    titleStyle={{ fontFamily: "MontserratBold", fontSize: 13, color: Message == "با موفقیت ثبت شد" ? Colors.success : Colors.primarydark }}
                    messageStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
                    confirmButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
                />


            </View>
        </NativeBaseProvider>


    );
}

const styles = StyleSheet.create({

    viewContainer: {
        width: "100%",
        height: "100%",
        backgroundColor: Colors.background,
        position: Platform.OS == "web" ? "fixed" : "relative"
    },
    viewHeader: {
        flexDirection: "row",
        width: "100%",
        height: Platform.OS == "web" ? 60 : 80,
        backgroundColor: Colors.primary,
    },
    viewmodal: {

        width: "100%",
        height: 55,
        marginBottom: 30,

        backgroundColor: Colors.background
    },
    viewline: {
        width: "100%",
        height: 30,
        justifyContent: "center",
        flexDirection: "row",
        marginTop: 5

    },

    textlineR: {
        fontFamily: "Montserrat",
        fontSize: 13,
        color: Colors.black,
        position: "absolute",
        right: "5%"

    },
    textline: {
        fontFamily: "Montserrat",
        fontSize: 13,
        color: Colors.secondText3,

    },

    menu: {
        backgroundColor: Colors.primary,
        width: 40,
        height: 40,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: 15,
        top: Platform.OS == "web" ? "15%" : "35%",

    },
    textheader: {
        backgroundColor: Colors.primary,
        width: 60,
        height: 40,
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        right: "12%",
        top: Platform.OS == "web" ? "15%" : "35%"
    },
    payam: {
        width: 60,
        height: 50,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        left: 15,
        top: "20%"
    },
    text: {
        fontFamily: "Montserrat",
        fontSize: 14,
        color: Colors.secondText3,
        textAlign: "right",
        marginTop: 30,
    },

})




export default Ticket